import { useExperimentVariant } from 'src/utils/experimentNew'
import { Experiments } from '../constants'

/**
 * control: existing dark payment modal
 * treatment: redesigned theme-aware full-screen page with order summary + clearer plan/cadence/total
 */
type Variant = 'control' | 'treatment'

const EXPERIMENT_KEY = Experiments.PaymentMethodPage

export function usePaymentMethodPageExperiment() {
  const { value } = useExperimentVariant<Variant>(EXPERIMENT_KEY, 'control')

  return {
    variant: value,
    isEnabled: value === 'treatment',
  }
}
